import React from 'react'

export const WaterIcon = (): JSX.Element => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="BgColors">
      <path
        id="Vector"
        d="M15.6789 15.1831C16.6544 15.1831 17.4512 14.375 17.4512 13.3862C17.4512 12.192 15.6789 10.2433 15.6789 10.2433C15.6789 10.2433 13.9066 12.192 13.9066 13.3862C13.9066 14.375 14.7035 15.1831 15.6789 15.1831ZM7.26151 14.1987C7.41999 14.3572 7.67669 14.3572 7.83294 14.1987L13.5495 8.4844C13.7079 8.32592 13.7079 8.06922 13.5495 7.91297L7.83517 2.19868C7.82178 2.18529 7.80615 2.1719 7.79053 2.16074L6.04499 0.415201C6.00694 0.377632 5.95561 0.356567 5.90213 0.356567C5.84866 0.356567 5.79733 0.377632 5.75928 0.415201L4.68785 1.48663C4.65028 1.52469 4.62922 1.57601 4.62922 1.62949C4.62922 1.68296 4.65028 1.73429 4.68785 1.77234L6.18785 3.27234L1.54946 7.91297C1.39097 8.07145 1.39097 8.32815 1.54946 8.4844L7.26151 14.1987ZM7.54946 4.18529L11.5428 8.17859H3.55838L7.54946 4.18529ZM18.7504 16.7835H1.25035C1.15213 16.7835 1.07178 16.8639 1.07178 16.9621V18.7478C1.07178 18.846 1.15213 18.9264 1.25035 18.9264H18.7504C18.8486 18.9264 18.9289 18.846 18.9289 18.7478V16.9621C18.9289 16.8639 18.8486 16.7835 18.7504 16.7835Z"
        fill="black"
      />
    </g>
  </svg>
)
